/**
 * Created by zhj on 3/25/2016.
 */
'use strict';

angular.module('betosyswebapp')
  .service('vehicleStatusDialogService', function (crudService) {

    this.getVehicleStatesComboList = function () {
      return crudService.get('portalcommands/vehiclestates');
    };
  })
  .controller('VehicleStatusDialogCtrl', function ($scope, $uibModalInstance, vehicleStatusDialogService, items, widgetSettingsCreatorService, vehiclesListService, $filter, vehicleStatusService, $translate, $timeout, $rootScope, toastService) {
    var selectedRow = vehiclesListService.getSelectedRow();
    var statusTimeoutObj = {};
    $scope.vehicleStatusDialog = {
      recordTime: new Date(),
      duration: '',
      stateName: items.stateName,
      deviceID: items.deviceID,
      statusCode: '',
      deviceDesc: selectedRow.devicedesc,
      stateDesc: selectedRow.jobstatusdesc,
      orderDate: selectedRow.date
    };

    $scope.startTimeWidget = {
      allowNullDate: true,
      formatString: 'HH:mm',
      showCalendarButton: false,
      
      theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, //'material', // theme: 'bootstrap',
      width: 68,
      height: 30
    };

    $scope.vehicleStateSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'displayName',
      valueMember: 'key'
    });

    var loadVehicleStates = function () {
      vehicleStatusDialogService.getVehicleStatesComboList().then(function (states) {
        $scope.vehicleStateSettings.source = states;
        var _translatedSttausCode = vehicleStatusService.convertGtsStatusCodeToBetoplanCode(selectedRow.jobstatuscode);
        $scope.vehicleStatusDialog.statusCode = _translatedSttausCode;
        if (_translatedSttausCode) {
          $scope.vehicleStatusDialog.state = getNextState(_translatedSttausCode);
        }
      }).finally(function () {
        $timeout(function () {
          $scope.dataLoadingFinished = true;
        }, 0);

      });
    };
    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.save = function (statusDesc) {

      var pendingCommandParams = vehicleStatusService.getPendingCommand($scope.vehicleStatusDialog.deviceID);
      var object = {};
      if (statusDesc === 'pauseBegin') {
        object = vehicleStatusService.getPendingCommandArgs(selectedRow.orderid, statusDesc);
        object.starttime = $filter('date')($scope.vehicleStatusDialog.recordTime, 'HH:mm') || null;
        object.duration = $scope.vehicleStatusDialog.duration || null;
      }
      if (statusDesc === 'vehicleState') {
        object = vehicleStatusService.getPendingCommandArgs(selectedRow.orderid, Number($scope.vehicleStatusDialog.state));
      }
      pendingCommandParams = _.extend(pendingCommandParams, object);
      return vehicleStatusService.savePendingCommand(pendingCommandParams).then(function () {
        toastService.showSuccessToast($translate.instant('vehicleStatus.operationSuccess'));
        statusTimeoutObj = $timeout(function () {
          $uibModalInstance.close();
        }, 100);
        $rootScope.$broadcast('portalCommandSaved');
      }, function () {
      });
    };
    loadVehicleStates();

    function getNextState(currentState) {
      var newState = null;
      for (var i = 0; i < $scope.vehicleStateSettings.source.length; i++) {
        if (Number($scope.vehicleStateSettings.source[i].key) === currentState + 1) {
          newState = $scope.vehicleStateSettings.source[i].key;
          break;
        }
      }
      return newState !== null ? newState : currentState;
    }

    $scope.$on('$destroy', function () {
    });
  });



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/vehicleStatus/vehicleStatusDialogController.js